import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class, _class2;
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { AbDragDropTarget } from "abreact/dragDrop/AbDragDropTarget";
import { ABLOGICTREE_SELECTABLE_CLASS } from "abreact/incubator/ui/abBooleanLogicTree/model/AbBooleanLogicTreeSelectionMachine";
import { CssUtils } from "abreact/incubator/ui/utils/CssUtils";
import { computed, makeObservable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
// import OperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperandValue;
// import OperatorOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.OperatorOperandValue;
// import Operand = GuidedExpressionEditor.Operand;
// import DragDrop = GuidedExpressionEditor.Operand.Value.Editor.DragDrop;

export let OperandValueEditor = observer(_class = (_class2 = class OperandValueEditor extends React.Component {
  constructor(props) {
    super(props);
    makeObservable(this);
  }
  render() {
    const className = CssUtils.composeClassNames("ab-vbox", "ab-gee-input-with-test-data-value-container");
    const dragDropMachine = this.props.componentFactory.getDragDropMachine();
    if (this.props.isReadonly || dragDropMachine == null) {
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, this.editorContents);
    } else {
      const dragOverContext = {
        valueCategoryID: this.props.valueCategoryID,
        operandValueContext: this.props.operandValueContext,
        operatorOperandValue: this.props.operatorOperandValue
      };
      const dropContext = {
        valueCategoryID: this.props.valueCategoryID,
        operandValue: this.props.operandValue,
        generateId: this.props.generateId,
        applyOperandValue: this.props.applyOperandValue
      };
      return /*#__PURE__*/React.createElement(AbDragDropTarget, {
        className: className,
        dataTestId: this.dataTestId,
        disabled: this.props.isBusy,
        dragDropMachine: dragDropMachine,
        dragOverContext: dragOverContext,
        dropContext: dropContext,
        onDragOver: this.props.dragDropEditorMachine?.onDragOver,
        onDrop: this.props.dragDropEditorMachine?.onDrop
      }, this.editorContents);
    }
  }
  get dataTestId() {
    return `${this.props.dataTestId}-drag-drop-target`;
  }
  get editorContents() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.inputEditor, this.testDataValue);
  }
  get inputEditor() {
    const {
      renderedValidationResult
    } = this;
    const className = renderedValidationResult != null ? "ab-gee-input-with-validation-issue-container" : "ab-gee-input-container";
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, this.props.renderOperandValueEditor(), renderedValidationResult);
  }
  get testDataValue() {
    const {
      liveViewSliceModel,
      operandValue
    } = this.props;
    let testDataValue;
    if (liveViewSliceModel != null && operandValue != null) {
      let testDataResult = liveViewSliceModel.findTestDataResult(operandValue.id);
      if (testDataResult != null && this.props.componentFactory.renderTestDataValueFromTestDataResult != null) {
        testDataValue = this.props.componentFactory.renderTestDataValueFromTestDataResult(testDataResult);
        if (testDataValue != null) {
          testDataValue = /*#__PURE__*/React.createElement("span", {
            className: "ab-gee-test-data-value"
          }, testDataValue);
        }
      }
    }
    testDataValue ??= this.props.componentFactory.onTestDataValueNotRendered?.();
    const className = CssUtils.composeClassNames("ab-gee-test-data-value-container", ABLOGICTREE_SELECTABLE_CLASS);
    if (testDataValue != null) {
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, testDataValue);
    }
  }
  get renderedValidationResult() {
    const {
      liveViewSliceModel,
      operandValue
    } = this.props;
    if (liveViewSliceModel != null && operandValue != null) {
      const validationResult = liveViewSliceModel.findValidationResult(operandValue.id);
      if (validationResult != null) {
        return this.props.componentFactory.renderValidationResult?.(validationResult);
      }
    }
  }
}, _applyDecoratedDescriptor(_class2.prototype, "dataTestId", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "dataTestId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "editorContents", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "editorContents"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "inputEditor", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "inputEditor"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "testDataValue", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "testDataValue"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "renderedValidationResult", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "renderedValidationResult"), _class2.prototype), _class2)) || _class;
//# sourceMappingURL=OperandValueEditor.js.map
